import * as t from "io-ts";
import { EventOptions } from "./EventOptions";
import { EventProps } from "./EventProps";
import { PurchaseEvent } from "./PurchaseEvent";

export const Event = t.intersection([
  t.type({
    name: t.union([
      t.literal("page-view"),
      t.literal("page-closed"),
      t.literal("page-error"),
      t.literal("signup-attempted"),
      t.literal("signup-succeeded"),
      t.literal("signup-failed"),
      t.literal("login-attempted"),
      t.literal("login-succeeded"),
      t.literal("login-failed"),
      t.literal("button-interacted"),
      t.literal("form-filled"),
      t.literal("form-submitted"),
      t.literal("form-error"),
      t.literal("api-attempted"),
      t.literal("api-succeeded"),
      t.literal("api-failed"),
      t.literal("comms-sent"),
      t.literal("onboarding-registered"),
      t.literal("onboarding-legacy"),
      t.literal("onboarding-billing-subscribed"),
      t.literal("onboarding-billing-referred"),
      t.literal("onboarding-billing-cancelled"),
      t.literal("onboarding-director-info-provided"),
      t.literal("onboarding-director-verified"),
      t.literal("onboarding-director-pending"),
      t.literal("onboarding-director-failed"),
      t.literal("onboarding-onboarded"),
      t.literal("onboarding-insurance-uploaded"),
      t.literal("onboarding-contract-signed"),
      t.literal("onboarding-completed"),
      t.literal("onboarding-verified"),
      t.literal("onboarding-rejected"),
      t.literal("onboarding-declined"),
    ]),
    event_options: EventOptions,
  }),
  t.partial({
    event_props: EventProps,
    purchase: PurchaseEvent,
  }),
]);

export interface Event {
  name:
    | "page-view"
    | "page-closed"
    | "page-error"
    | "signup-attempted"
    | "signup-succeeded"
    | "signup-failed"
    | "login-attempted"
    | "login-succeeded"
    | "login-failed"
    | "button-interacted"
    | "form-filled"
    | "form-submitted"
    | "form-error"
    | "api-attempted"
    | "api-succeeded"
    | "api-failed"
    | "comms-sent"
    | "onboarding-registered"
    | "onboarding-legacy"
    | "onboarding-billing-subscribed"
    | "onboarding-billing-referred"
    | "onboarding-billing-cancelled"
    | "onboarding-director-info-provided"
    | "onboarding-director-verified"
    | "onboarding-director-pending"
    | "onboarding-director-failed"
    | "onboarding-onboarded"
    | "onboarding-insurance-uploaded"
    | "onboarding-contract-signed"
    | "onboarding-completed"
    | "onboarding-verified"
    | "onboarding-rejected"
    | "onboarding-declined";
  event_options: EventOptions;
  event_props?: EventProps;
  purchase?: PurchaseEvent;
}
